import { OrigemDocumentoFiscalRecebidoEnum } from '../../../enums/repo-dfe/origem-documento-fiscal-recebido.enum';

export class DocumentoFiscalRecebidoDownloadStruct {
    idDFeRecebido: number;
    idModeloDocumento: number;
    origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum;
}
